export default __webpack_public_path__ + "static/media/bt.7a0edfc5.jpg";